export const BRAND = {
  name: "FS Mountain Skills",
  tagline: "Climbing instruction in Lancashire & the Lake District",
  email: "fraserstubbs10@gmail.com",
  phone: "+447900263502",
  locations: ["Lancashire", "Lake District"],
  logo:
    "https://customer-assets.emergentagent.com/job_peak-guide-1/artifacts/peolajxf_FS_greyBG.jpg",
};

// All imagery is from the Lake District / Cumbria & Lancashire fells (Unsplash, free use).
const U = (id) =>
  `https://images.unsplash.com/photo-${id}?fm=jpg&q=80&w=1600&auto=format&fit=crop`;

export const IMAGES = {
  // Hero — Lake District fells panorama
  hero: U("1693164650083-7801755ae567"),
  // Service — Beginner: rocky Lake District crag/mountain
  beginner: U("1609093411427-c00dfe50ad62"),
  // Service — Group abseil: Lakeland mountain lake / rocky shore
  abseil: U("1648409395915-7b6d0a1a35da"),
  // Service — Private single pitch: green & brown Lakeland mountain
  privatePitch: U("1628178703824-59fb9c85637f"),
  // About — Lakeland fellside path
  about: U("1606489853471-a8e180faefeb"),
  // Gallery
  gallery1: U("1660991061704-498e36c1aa5a"),
  gallery2: U("1693164610443-f034e1fb4fc6"),
  gallery3: U("1605989603799-ff52a0e80cc8"),
  gallery4: U("1628178703784-708002439948"),
};

export const SERVICES = [
  {
    id: "beginner",
    title: "Beginner Rock Climbing",
    overline: "Course",
    blurb:
      "Your first day on real Lakeland or Lancashire rock — learn knots, belaying, footwork and movement on hand-picked outcrops. All technical gear provided.",
    duration: "Full day · 6 hrs",
    group: "Up to 4 climbers",
    price: "From £75 / person",
    image: IMAGES.beginner,
    features: [
      "Knots & belay technique",
      "Top-rope climbing on real rock",
      "Movement & footwork coaching",
      "All technical kit provided",
    ],
  },
  {
    id: "abseil",
    title: "Group & Charity Abseils",
    overline: "Group event",
    blurb:
      "Bespoke abseil days for charities, schools, stag/hen groups and corporate teams. We rig safe lines on dramatic Lakeland crags and look after everyone, top to bottom.",
    duration: "Half / full day",
    group: "8–60 people",
    price: "Bespoke quote",
    image: IMAGES.abseil,
    features: [
      "Fundraising & charity events",
      "School & youth groups",
      "Corporate team-building",
      "Fully insured & risk-assessed",
    ],
  },
  {
    id: "private",
    title: "Private Single Pitch",
    overline: "1:1 / 1:2",
    blurb:
      "Focused private coaching with a Mountain Training qualified instructor on classic single pitch routes — tailored entirely to what you want to get out of the day.",
    duration: "Half / full day",
    group: "1–2 climbers",
    price: "From £180 / day",
    image: IMAGES.privatePitch,
    features: [
      "Tailored to your goals",
      "Movement & technique coaching",
      "Anchors & safe systems",
      "Choice of crag",
    ],
  },
];

export const FAQS = [
  {
    q: "Do I need any experience?",
    a: "Not at all. Our beginner and group sessions are designed for first-timers. All technical equipment is provided — you just need walking boots or trainers and weather-appropriate clothing.",
  },
  {
    q: "Where do you operate?",
    a: "Across Lancashire and the Lake District National Park. Popular venues include Denham Quarry, Long Scar, Wilton, Anglezarke and Trowbarrow — we'll choose the best crag for the conditions on the day.",
  },
  {
    q: "Are you insured and qualified?",
    a: "Yes. All sessions are delivered under appropriate Mountain Training qualifications and we hold full instructor public liability insurance. Risk assessments are completed for every venue.",
  },
  {
    q: "What happens if the weather is bad?",
    a: "Climbing happens rain or shine where possible — but if conditions become unsafe we'll either find a sheltered venue, switch to indoor coaching, or reschedule free of charge.",
  },
  {
    q: "How do I pay?",
    a: "Submit an enquiry below and we'll confirm availability and send a booking link. A small deposit secures your date with the balance payable on the day.",
  },
];
